export const costs = [
  'Sleepless nights searching for ways to translate complex environmental concepts into language your students can understand.',
  "Improvised classes because you couldn't find clear, ready-to-use materials in time.",
  "Disconnected students who don't see how environmental management connects to their careers, communities, or futures.",
  "Awkward silences when a student asks about pollution solutions or sustainable development and you don't have a clear answer.",
  'Weekends lost building lesson plans, environmental projects, and assessments from scratch over and over.',
  'Uncertainty about how to teach environmental systems, pollution prevention, or circular economy without adequate resources.',
];
